<app-badge
  [badgeStyleClass]="badgeStyleClass"
  [text]="text"
  [size]="size"
  [circle]="true"
  [color]="color">
</app-badge>
